import ModalDropdownItemTriggerExample from "../../../../../../packages/design-system/entry-points/examples/constellation/modal-dropdown-item-trigger";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_dropdown_item_trigger from "!!raw-loader!../../../../../../packages/design-system/entry-points/examples/constellation/modal-dropdown-item-trigger";
import * as React from 'react';
export default {
  ModalDropdownItemTriggerExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_dropdown_item_trigger,
  React
};